import type { TTodayAppointmentItem } from './types';

export const sanitizeAppointments = (
  appointments?: Array<TTodayAppointmentItem | null | undefined>,
): TTodayAppointmentItem[] =>
  appointments?.filter((item): item is TTodayAppointmentItem =>
    Boolean(item),
  ) ?? [];
